module.exports = __webpack_public_path__ + "img/giftIcon.0d9e51d0.png";